import { StatusBar, Style } from '@capacitor/status-bar';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
import PlatformHelper from 'web-app/helpers/platform-helper';
import { currentTheme } from 'web-app/styleguide';
import { hslStringToRgb, isHSLA } from '@famly/vet_ts-utils_generic-hooks';
/*
 * Status bar operations
 */
export const setStatusBar = (style) => {
    if (!PlatformHelper.hasDynamicStatusBar()) {
        return new Promise(resolve => resolve());
    }
    return Promise.all([
        StatusBar.setStyle({ style }),
        PlatformHelper.isAndroid()
            ? EdgeToEdge.setStatusBarColor({ color: styleToBackgroundColor(style) })
            : Promise.resolve(),
    ]);
};
const styleToBackgroundColor = (style) => {
    const chromeColor = currentTheme().chromeColor;
    const hexChromeColor = isHSLA(chromeColor) ? hslStringToRgb(chromeColor) : chromeColor;
    switch (style) {
        case Style.Light:
            return currentTheme().invertedText;
        case Style.Dark:
            return hexChromeColor;
        default:
            return hexChromeColor;
    }
};
